import { Button } from '@opositandopn/ui';
import classnames from 'classnames';

import { BaseComponentProps } from '../../../../types/base-component.types';
import { PlayerViewModel } from '../../../challenges/api/useChallenges';
import { ChallengeRanking } from '../layout/ChallengeRanking';
import { ChallengeResults } from '../layout/ChallengeResults';

import styles from './Result.module.scss';

export type ContainerProps = BaseComponentProps & {
  players: PlayerViewModel[];
  onReady: () => void;
};

function Result({
  className,
  players,
  onReady,
  testId = 'ui-challenge-result',
}: ContainerProps) {
  return (
    <div
      className={classnames(styles['main'], className)}
      data-test-id={testId}
    >
      <ChallengeResults players={players} />
      <ChallengeRanking players={players} playersColumn="Usuario" />
      <Button
        variant="outline-primary"
        className={styles['button']}
        onClick={onReady}
      >
        Volver al inicio
      </Button>
    </div>
  );
}

export { Result };
